import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconStrikethrough = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M15.0586 6.90137H11.8763C10.7503 6.90137 9.62109 7.81396 9.62109 8.94043C9.62109 11.999 15.0586 11.999 15.0586 15.0576C15.0586 15.3254 15.0059 15.5905 14.9034 15.8379C14.8009 16.0853 14.6507 16.3101 14.4614 16.4995C14.272 16.6888 14.0472 16.839 13.7998 16.9415C13.5525 17.0439 13.2873 17.0967 13.0195 17.0967H9.62109"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.90234 12.3389H17.0977"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconStrikethrough.displayName = 'IconStrikethrough';
